module.exports = __webpack_public_path__ + "static/media/tiger-wp.04e6b48f.jpg";